import { Modal, MODAL_SIZES } from 'components/ModalV2';
import { useLocationConsent } from 'hooks';
import { PudoLocation } from '@pperform/pp-data-mappers';
import { FunctionComponent } from 'preact';
import { useState } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import { ReturnShipment } from '../../../../../models/ReturnShipment.model';
import {
  CHOOSE_DROP_OFF_LOCATION_STEP,
  CONFIRM_DROP_OFF_LOCATION_STEP,
  useSteps,
} from '../../../hooks';
import { ChooseDropOffLayout } from '../ChooseDropOffLayout';
import { ConfirmDropOffLayout } from '../ConfirmDropOffLayout';

interface DropOffModalProps {
  isOpen: boolean;
  onClose: () => void;
  shipment: ReturnShipment;
}

const DropOffModal: FunctionComponent<DropOffModalProps> = ({
  isOpen,
  onClose,
  shipment,
}): JSX.Element => {
  const { t } = useTranslation();
  const { currentStep, goToNextStep, goToPreviousStep } = useSteps();
  const [selectedDropOff, setSelectedDropOff] =
    useState<PudoLocation>(undefined);

  const onSaveDropOffLocation = (selectedDropOff: PudoLocation) => {
    setSelectedDropOff(selectedDropOff);
  };

  const isChooseLocationStep = currentStep === CHOOSE_DROP_OFF_LOCATION_STEP;

  const { isAllowGoogleMaps } = useLocationConsent();

  return (
    <Modal
      size={isAllowGoogleMaps ? MODAL_SIZES.lg : MODAL_SIZES.sm}
      isOpen={isOpen}
      onClose={onClose}
      closable={isChooseLocationStep}
      aria={{
        labelledby: 'drop-off-modal-heading',
      }}
    >
      <Modal.Header id="drop-off-modal-heading">
        {isChooseLocationStep
          ? t('RETURN_CHOOSE_A_LOCATION')
          : t('RETURN_CONFIRM_SELECTED_DROPOFF')}
      </Modal.Header>
      <Modal.Body>
        <ChooseDropOffLayout
          isShow={isChooseLocationStep}
          goToNextStep={goToNextStep}
          onSaveDropOffLocation={onSaveDropOffLocation}
        />

        {currentStep === CONFIRM_DROP_OFF_LOCATION_STEP && (
          <ConfirmDropOffLayout
            goToPreviousStep={goToPreviousStep}
            selectedDropOff={selectedDropOff}
            closeDropOffModal={onClose}
            shipment={shipment}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export { DropOffModal };
